<template>
  <div class="new_top2" style="background: #fff;width:1002px;border-bottom-color: #91c0ec;">
    <div class="nt2_logo" style="padding-left: 15px;"><img src="../assets/img/shiyan_logo.jpg" width="365" height="74"></div>
    <div class="nt2_title" style="left:397px;">{{title}}</div>
    <router-link to="/" target="_self" class="nt2_goindex" style="color: #1d7a8e;margin-right: 15px;">网站首页</router-link>
  </div>
</template>
<script>
  export default {
    props: {
      title: {
        type: String
      }
    }
  }
</script>

<style scope>

</style>



// WEBPACK FOOTER //
// src/components/Header1.vue